import {
  PulseFilters,
  PulsePaginatedFilters,
  pulseFiltersSchema,
  pulsePaginatedFiltersSchema,
} from './types'

import { api } from 'api'
import { z } from 'zod'

const ratingsByLocationResponse = z.array(
  z.object({
    company_name: z.string(),
    avg_worker_rating_by_shift: z.number().nullable().optional(),
    avg_shift_rating_by_worker: z.number().nullable().optional(),
    count_worker_rating_by_shift: z.number().nullable().optional(),
    count_shift_rating_by_worker: z.number().nullable().optional(),
    number_workers_rated_shift_below_3: z.number().nullable().optional(),
    number_shifts_rated_worker_below_3: z.number().nullable().optional(),
  })
)

export type RatingsByLocation = z.infer<typeof ratingsByLocationResponse>

export async function getRatingsByLocation(
  filters: PulsePaginatedFilters,
  signal?: AbortSignal
) {
  const data = pulsePaginatedFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/ratings_by_location', data, { signal })
    .then((res) => res.data.ratings_by_location)
}

export async function getRatingsByLocationCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/ratings_by_location/csv', data, {
      signal,
    })
    .then((response) => response.data)
}
